/** Energy — HVAC usage report /energy/charging-sankey (chargingReport.vue) */
export default {
  chargingReport: {
    filterStatPeriod: 'Period',
    phDateStart: 'Start',
    phDateEnd: 'End',
    filterTenant: 'Tenant',
    phTenant: 'Select tenant',
    filterAir: 'HVAC unit',
    phAir: 'Select unit',
    exportLoading: 'Exporting...',
    exportReport: 'Export',
    exportCurrentPage: 'Export current page',
    exportAll: 'Export all',
    loadingText: 'Loading...',
    sectionTitle: 'HVAC electricity',
    sectionTip: 'Pick a date range to load data',
    colOutdoor: 'Outdoor system',
    colMeter: 'Billing meter',
    colMeterTotalKwh: 'Meter total (kWh)',
    colAirName: 'Indoor unit',
    colBindInfo: 'Binding',
    summaryGroup: 'Subtotal',
    colTotalTime: 'Total time',
    colTotalKwh: 'Total kWh',
    colTotalSysKwh: 'System total (kWh)',
    colTotalFee: 'Total (CNY)',
    suffixDuration: ' time',
    suffixElec: ' kWh',
    suffixSysElec: ' system (kWh)',
    sysElecSubHead: 'System (kWh)',
    suffixFee: ' cost',
    emptyNoData: 'No data',
    tenantAll: 'All',
    airAll: 'All',
    unitHours: 'h',
    pickerLast7: 'Last 7 days',
    pickerLast15: 'Last 15 days',
    pickerLast30: 'Last 30 days',
    pickerThisMonth: 'This month',
    pickerLastMonth: 'Last month',
    msgTenantListFail: 'Failed to load tenants',
    msgAirListFail: 'Failed to load HVAC list',
    msgDateMax31: 'Range cannot exceed 31 days',
    msgFetchFail: 'Failed to load data',
    msgExportEmpty: 'Nothing to export',
    msgExportOk: 'Export completed',
    msgExportLimit: '{total} row(s) in total, first {count} row(s) exported',
    msgExportFail: 'Export failed',
    msgExportRetry: 'Try again',
    exportFilterLine: 'Period: {start} – {end} | Tenant: {tenant} | HVAC: {air}',
    exportSheetName: 'HVAC usage',
    exportFilePrefix: 'hvac_usage',
    expColOutdoor: 'Outdoor system',
    expColMeter: 'Meter',
    expColMeterTotal: 'Meter total (kWh)',
    expColAirName: 'Indoor unit',
    expColBind: 'Binding',
    expSummary: 'Subtotal',
    expTotalTime: 'Total time',
    expTotalKwh: 'Total kWh',
    expTotalSysKwh: 'System total (kWh)',
    expTotalFee: 'Total (CNY)'
  }
}
